import { LOAN_PURPOSE_LIST } from 'embed/constants'
import { brandFromHost } from 'embed/constants/config'
import { DEFAULT_THEME } from 'embed/constants/theme'
import {
  Config,
  ConfigServiceDataKeys,
  LoanPurposeOptions,
  QueryParamKeys,
  THEME_QUERY_PARAM_PREFIX,
} from '@evenfinancial/even-ts-static'

const brand = brandFromHost
export const DEFAULT_CONFIG: Config = {
  ...Object.fromEntries(
    Object.entries(DEFAULT_THEME).map(([key, value]) => [`${THEME_QUERY_PARAM_PREFIX}${key}`, value]),
  ),
  [ConfigServiceDataKeys.brand]: brand,
  [ConfigServiceDataKeys.partner]: brand,
  [ConfigServiceDataKeys.shouldAutoRedirect]: true,
  [ConfigServiceDataKeys.shouldDisplayNavigation]: false,
  [QueryParamKeys.MaxResults]: 10,
  [ConfigServiceDataKeys.loanPurposeOptions]: LOAN_PURPOSE_LIST.map((option) => option.value) as LoanPurposeOptions[],
}
